// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"c667a409","227":"d156b79b","453":"28b1b153","762":"bc48800e"}[chunkId] + ".chunk.js";
};